module.exports = __webpack_public_path__ + "static/media/August2021Newsletter.7270b987.pdf";